module.exports = __webpack_public_path__ + "img/Notification.b1aa68a3.svg";